import { render } from "./FileTranslate.vue?vue&type=template&id=cef2b32e&scoped=true"
import script from "./FileTranslate.vue?vue&type=script&lang=js"
export * from "./FileTranslate.vue?vue&type=script&lang=js"

import "./FileTranslate.vue?vue&type=style&index=0&id=cef2b32e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef2b32e"]])

export default __exports__